import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import ADMIN_API_URL from "../../../config/AdminApiUrl";

export const getEmailProviders = createAsyncThunk(
  "EmailProvider/get",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      dispatch(setActivePayload(payload));
      const filteredPayload = Object.fromEntries(
        Object.entries(payload).filter(
          ([, value]) => value !== null && value !== undefined && value !== ""
        )
      );
      const params = new URLSearchParams();

      for (const [key, value] of Object.entries(filteredPayload)) {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            params.append(key, item);
          });
        } else {
          params.append(key, value);
        }
      }
      const queryString = params.toString();

      const { data } = await axios.get(
        `${ADMIN_API_URL.EMAIL_PROVIDER.SLUG}?${queryString}`
      );
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createProvider = createAsyncThunk(
  "EmailProvider/create",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${ADMIN_API_URL.EMAIL_PROVIDER.SLUG}`,
        payload
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const editProvider = createAsyncThunk(
  "EmailProvider/put",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await axios.put(
        `${ADMIN_API_URL.EMAIL_PROVIDER.SLUG}/${payload.id}`,
        payload
      );
      dispatch(getEmailProviderDetail(payload.id));
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const deleteProvider = createAsyncThunk(
  "EmailProvider/delete",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.delete(
        `${ADMIN_API_URL.EMAIL_PROVIDER.SLUG}/${payload}`
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const getEmailProviderDetail = createAsyncThunk(
  "EmailProviderDetail/get",
  async (Id, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${ADMIN_API_URL.EMAIL_PROVIDER.SLUG}/${Id}`
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const emailProviderSlice = createSlice({
  name: "emailProvider",
  initialState: {
    provider_list: [],
    current_values: null,
    active_payload: null,
    provider_detail: null,
  },
  reducers: {
    setCurrentValues(state, action) {
      state.current_values = action.payload;
    },
    setActivePayload(state, action) {
      state.active_payload = action.payload;
    },
    resetCurrentValue(state) {
      state.current_values = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getEmailProviders.fulfilled, (state, action) => {
        state.provider_list = action.payload.data;
      })
      .addCase(getEmailProviderDetail.fulfilled, (state, action) => {
        state.provider_detail = action.payload;
      });
  },
});

export const { setCurrentValues, setActivePayload, resetCurrentValue } =
  emailProviderSlice.actions;
export default emailProviderSlice.reducer;
